import DefaultOptionsMenu, {
  type DefaultOptionsMenuProps,
} from '@/components/DefaultOptionsMenu';
import { MenuItem } from '@/components/Menu';
import { DownloadIcon } from '@/icons';

export interface FormSubmissionMenuProps extends Omit<
  DefaultOptionsMenuProps,
  'extraOptions'
> {
  onDownload: () => void;
  onEdit: () => void;
  onDelete: () => void;
}

export default function FormSubmissionMenu({
  onDownload,
  onEdit,
  onDelete,
  ...props
}: FormSubmissionMenuProps) {
  const handleClick = (cb: () => void) => {
    return () => {
      cb();
      props.onClose();
    };
  };

  return (
    <DefaultOptionsMenu
      extraOptions={[
        <MenuItem
          key="download"
          label="Download"
          icon={<DownloadIcon />}
          onClick={handleClick(onDownload)}
        />,
      ]}
      onEdit={handleClick(onEdit)}
      onDelete={handleClick(onDelete)}
      {...props}
    />
  );
}
